const NGW_SB_URL = 'https://dgkfpzmogwphxgbzmjiw.supabase.co';
const NGW_SB_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRna2Zwem1vZ3dwaHhnYnptaml3Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc4ODg3OTUxOCwiZXhwIjoyMTA0NDU1NTE4fQ.5Seayv4VZmwiotdyCb5XTaugp9HmjHz5KAh4SBt0oaI';

// ─── State ────────────────────────────────────────────────────────────────────
let ngwCart           = [];
let ngwState          = { clubId: null, modelName: null, clubType: null, condition: null, conditionLabel: null, price: null };
let ngwAllClubs       = [];
let ngwSearchDebounce = null;

const NGW_CONDITIONS = [
  { slug: 'like_new',        name: 'Like new',        desc: 'No visible wear. Looks brand new.' },
  { slug: 'excellent_shape', name: 'Excellent shape',  desc: 'Minor bag chatter. Face and sole clean.' },
  { slug: 'great',           name: 'Great',            desc: 'Light scuffs. No dents or deep face marks.' },
  { slug: 'good',            name: 'Good',             desc: 'Visible wear. Fully functional.' },
];

// ─── Supabase helpers ─────────────────────────────────────────────────────────
async function ngwSbGet(path) {
  const res = await fetch(`${NGW_SB_URL}/rest/v1/${path}`, {
    headers: { 'apikey': NGW_SB_KEY, 'Authorization': `Bearer ${NGW_SB_KEY}`, 'Accept': 'application/json', 'Range-Unit': 'items', 'Range': '0-9999' }
  });
  if (!res.ok) throw new Error(`Supabase error: ${res.status}`);
  return res.json();
}

async function ngwSbGetRange(path, offset) {
  const res = await fetch(`${NGW_SB_URL}/rest/v1/${path}&offset=${offset}&limit=1000`, {
    headers: { 'apikey': NGW_SB_KEY, 'Authorization': `Bearer ${NGW_SB_KEY}`, 'Accept': 'application/json' }
  });
  if (!res.ok) return [];
  return res.json();
}

// ─── Init ─────────────────────────────────────────────────────────────────────
async function ngwInit() {
  try {
    let all = [], offset = 0, batch;
    do {
      batch = await ngwSbGetRange('clubs?select=id,brand,model,club_type&order=brand.asc,model.asc', offset);
      all = all.concat(batch);
      offset += 1000;
    } while (batch.length === 1000);
    ngwAllClubs = all;
    ngwLoadBrands();
  } catch(e) { console.error('NGW init error', e); }
  ngwInitListeners();
}

function ngwLoadBrands() {
  const brands = [...new Set(ngwAllClubs.map(c => c.brand))].sort();
  const sel = document.getElementById('ngw-sel-brand');
  if (!sel) return;
  sel.innerHTML = '<option value="">Select a brand</option>';
  brands.forEach(b => { const o = document.createElement('option'); o.value = b; o.textContent = b; sel.appendChild(o); });
}

function ngwInitListeners() {
  // ── Step 1: Continue button ──
  const btnStep1 = document.getElementById('ngw-btn-step1');
  if (btnStep1) btnStep1.addEventListener('click', ngwCompleteStep1);

  // ── Step 1: Search input ──
  const searchInput = document.getElementById('ngw-search-input');
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      const q = this.value.trim();
      clearTimeout(ngwSearchDebounce);
      document.getElementById('ngw-search-clear').classList.toggle('visible', q.length > 0);
      if (q.length < 2) { ngwHideResults(); return; }
      ngwSearchDebounce = setTimeout(() => ngwRunSearch(q), 150);
    });
    searchInput.addEventListener('keydown', function(e) {
      const items = document.querySelectorAll('#ngw-search-results .search-result-item');
      let focused = document.querySelector('#ngw-search-results .search-result-item.focused');
      if (e.key === 'ArrowDown') { e.preventDefault(); const next = focused ? focused.nextElementSibling : items[0]; if (next) { if (focused) focused.classList.remove('focused'); next.classList.add('focused'); } }
      if (e.key === 'ArrowUp')   { e.preventDefault(); const prev = focused ? focused.previousElementSibling : null; if (prev) { focused.classList.remove('focused'); prev.classList.add('focused'); } }
      if (e.key === 'Enter' && focused) focused.click();
      if (e.key === 'Escape') ngwHideResults();
    });
  }

  // ── Step 1: Clear button ──
  const clearBtn = document.getElementById('ngw-search-clear');
  if (clearBtn) clearBtn.addEventListener('click', ngwClearSearch);

  // ── Step 1: Browse toggle ──
  const browseToggle = document.getElementById('ngw-browse-toggle');
  if (browseToggle) browseToggle.addEventListener('click', ngwToggleBrowse);

  // ── Step 1: Browse dropdowns ──
  const brandSel = document.getElementById('ngw-sel-brand');
  if (brandSel) brandSel.addEventListener('change', function() {
    const typeSel = document.getElementById('ngw-sel-type');
    ngwResetSelect(typeSel, 'Select type', true);
    ngwResetSelect(document.getElementById('ngw-sel-model'), 'Select model', true);
    document.getElementById('ngw-btn-step1').disabled = true;
    ngwState.clubId = null; ngwState.modelName = null;
    if (!this.value) return;
    const types = [...new Set(ngwAllClubs.filter(c => c.brand === this.value).map(c => c.club_type))].sort();
    types.forEach(t => { const o = document.createElement('option'); o.value = t; o.textContent = ngwFriendlyType(t); typeSel.appendChild(o); });
    typeSel.disabled = false;
  });

  const typeSel = document.getElementById('ngw-sel-type');
  if (typeSel) typeSel.addEventListener('change', function() {
    const brand = document.getElementById('ngw-sel-brand').value;
    const selModel = document.getElementById('ngw-sel-model');
    ngwResetSelect(selModel, 'Select model', true);
    document.getElementById('ngw-btn-step1').disabled = true;
    ngwState.clubId = null; ngwState.modelName = null;
    if (!this.value) return;
    const models = ngwAllClubs.filter(c => c.brand === brand && c.club_type === this.value);
    models.forEach(r => { const o = document.createElement('option'); o.value = r.id; o.textContent = r.model; selModel.appendChild(o); });
    selModel.disabled = false;
  });

  const modelSel = document.getElementById('ngw-sel-model');
  if (modelSel) modelSel.addEventListener('change', function() {
    if (this.value) {
      const brand = document.getElementById('ngw-sel-brand').value;
      ngwState.clubId    = parseInt(this.value);
      ngwState.modelName = `${brand} ${this.options[this.selectedIndex].text}`;
      ngwState.clubType  = document.getElementById('ngw-sel-type').value;
    } else {
      ngwState.clubId = null; ngwState.modelName = null;
    }
    document.getElementById('ngw-btn-step1').disabled = !this.value;
  });

  // ── Step 2: Get my quote button ──
  const btnStep2 = document.getElementById('ngw-btn-step2');
  if (btnStep2) btnStep2.addEventListener('click', ngwCompleteStep2);

  // ── Step 3: Add another / Accept buttons (rendered in HTML, need IDs) ──
  // These are wired by delegated click since they have no IDs in the HTML
  document.addEventListener('click', function(e) {
    // Close search results when clicking outside
    if (!e.target.closest('.search-wrap')) ngwHideResults();
  });

  // Wire step 3 buttons via event delegation on the step-body
  const step3Body = document.querySelector('#ngw-step-3 .step-body');
  if (step3Body) {
    step3Body.addEventListener('click', function(e) {
      const btn = e.target.closest('button');
      if (!btn) return;
      if (btn.textContent.includes('Add Another Club')) ngwAddAnotherClub();
      if (btn.textContent.includes('Accept')) ngwAcceptAndContinue();
      if (btn.textContent.includes('Start over')) ngwRestartWidget();
    });
  }

  // ── Cart buttons ──
  const cartEl = document.getElementById('ngw-cart');
  if (cartEl) {
    cartEl.addEventListener('click', function(e) {
      const btn = e.target.closest('button');
      if (!btn) return;
      if (btn.classList.contains('ngw-cart-remove')) {
        const idx = parseInt(btn.dataset.index);
        ngwRemoveFromCart(idx);
      }
      if (btn.textContent.includes('Add Another Club')) ngwAddAnotherClub();
      if (btn.textContent.includes('Accept') || btn.textContent.includes('Submit')) ngwGoToContact();
    });
  }

  // ── Success: add more clubs ──
  const successPanel = document.getElementById('ngw-success-panel');
  if (successPanel) {
    successPanel.addEventListener('click', function(e) {
      const btn = e.target.closest('button');
      if (btn && btn.textContent.includes('Add more')) ngwRestartWidget();
    });
  }

  // ── Step 4: Submit button ──
  const btnSubmit = document.getElementById('ngw-btn-submit');
  if (btnSubmit) btnSubmit.addEventListener('click', ngwSubmitTradein);
}

// ─── Search ───────────────────────────────────────────────────────────────────
function ngwRunSearch(q) {
  const terms = q.toLowerCase().split(/\s+/);
  const results = ngwAllClubs.filter(club => {
    const hay = `${club.brand} ${club.model} ${ngwFriendlyType(club.club_type)}`.toLowerCase();
    return terms.every(t => hay.includes(t));
  }).slice(0, 12);
  const container = document.getElementById('ngw-search-results');
  container.innerHTML = '';
  if (!results.length) {
    container.innerHTML = `<div class="search-no-results">No results for <strong>${q}</strong> — try a different search or browse by brand.</div>`;
    container.classList.add('visible'); return;
  }
  results.forEach(club => {
    const item = document.createElement('div');
    item.className = 'search-result-item';
    item.innerHTML = `<div><div class="search-result-name">${club.brand} ${club.model}</div><div class="search-result-meta">${ngwFriendlyType(club.club_type)}</div></div><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>`;
    item.addEventListener('click', () => ngwSelectClub(club));
    container.appendChild(item);
  });
  container.classList.add('visible');
}

function ngwHideResults() {
  const c = document.getElementById('ngw-search-results');
  if (c) { c.classList.remove('visible'); c.innerHTML = ''; }
}

function ngwSelectClub(club) {
  ngwState.clubId    = club.id;
  ngwState.modelName = `${club.brand} ${club.model}`;
  ngwState.clubType  = club.club_type;
  document.getElementById('ngw-search-input').value = ngwState.modelName;
  document.getElementById('ngw-search-clear').classList.add('visible');
  ngwHideResults();
  document.getElementById('ngw-btn-step1').disabled = false;
}

function ngwClearSearch() {
  ngwState.clubId = null; ngwState.modelName = null;
  document.getElementById('ngw-search-input').value = '';
  document.getElementById('ngw-search-clear').classList.remove('visible');
  document.getElementById('ngw-btn-step1').disabled = true;
  ngwHideResults();
}

function ngwToggleBrowse() {
  const section = document.getElementById('ngw-browse-section');
  const btn     = document.getElementById('ngw-browse-toggle');
  if (!section) return;
  const open = section.classList.toggle('visible');
  if (btn) btn.textContent = open ? 'Hide browse' : 'Browse by brand instead';
}

// ─── Step 1 → Step 2 ──────────────────────────────────────────────────────────
function ngwCompleteStep1() {
  if (!ngwState.clubId) return;
  document.getElementById('ngw-step-1-summary').textContent = ngwState.modelName;
  ngwSetStepDone(1);
  ngwSetStepActive(2);
  ngwBuildConditionGrid();
  // Show iron set note if applicable
  const ironNote = document.getElementById('ngw-iron-set-note');
  if (ironNote) ironNote.style.display = (ngwState.clubType === 'iron_set') ? 'block' : 'none';
  document.getElementById('ngw-step-2').scrollIntoView({ behavior: 'smooth' });
}

function ngwBuildConditionGrid() {
  const grid = document.getElementById('ngw-condition-grid');
  if (!grid) return;
  grid.innerHTML = '';
  NGW_CONDITIONS.forEach(c => {
    const card = document.createElement('div');
    card.className = 'condition-card';
    card.dataset.slug = c.slug;
    card.innerHTML = `<div class="condition-name">${c.name}</div><div class="condition-desc">${c.desc}</div>`;
    card.addEventListener('click', () => {
      document.querySelectorAll('.ngw-ti .condition-card').forEach(x => x.classList.remove('selected'));
      card.classList.add('selected');
      ngwState.condition      = c.slug;
      ngwState.conditionLabel = c.name;
      document.getElementById('ngw-btn-step2').disabled = false;
    });
    grid.appendChild(card);
  });
}

// ─── Step 2 → Step 3 (Quote) ──────────────────────────────────────────────────
async function ngwCompleteStep2() {
  if (!ngwState.condition) return;
  const btn = document.getElementById('ngw-btn-step2');
  btn.disabled = true;
  btn.classList.add('btn-loading');
  try {
    const rows = await ngwSbGet(`pricing?club_id=eq.${ngwState.clubId}&condition_slug=eq.${ngwState.condition}&variant_id=is.null&limit=1`);
    if (!rows.length || !rows[0].ngw_price_cad) {
      alert('Price not available for this club/condition.');
      btn.disabled = false; btn.classList.remove('btn-loading');
      return;
    }
    ngwState.price = parseFloat(rows[0].ngw_price_cad);
    document.getElementById('ngw-step-2-summary').textContent = ngwState.conditionLabel;
    ngwSetStepDone(2);
    ngwShowQuote();
  } catch(e) {
    alert('Error fetching price. Please try again.');
    btn.disabled = false; btn.classList.remove('btn-loading');
  }
}

function ngwShowQuote() {
  const price  = ngwState.price;
  const bonus  = Math.round(price * 0.20 * 100) / 100;
  const total  = Math.round((price + bonus) * 100) / 100;

  const fmt = v => `$${v.toFixed(2)}`;

  // Fill in quote box elements
  const quoteDollars = document.getElementById('ngw-quote-dollars');
  if (quoteDollars) quoteDollars.textContent = price.toFixed(2);

  const bonusBase   = document.getElementById('ngw-bonus-base');
  const bonusAmount = document.getElementById('ngw-bonus-amount');
  const bonusTotal  = document.getElementById('ngw-bonus-total');
  if (bonusBase)   bonusBase.textContent   = fmt(price);
  if (bonusAmount) bonusAmount.textContent = fmt(bonus);
  if (bonusTotal)  bonusTotal.textContent  = fmt(total);

  const clubDesc = document.getElementById('ngw-quote-club-desc');
  if (clubDesc) clubDesc.textContent = `${ngwState.modelName} · ${ngwState.conditionLabel}`;

  ngwSetStepActive(3);
  document.getElementById('ngw-step-3').scrollIntoView({ behavior: 'smooth' });
}

// ─── Step 3 actions ───────────────────────────────────────────────────────────
function ngwAddAnotherClub() {
  // Save current club to cart
  const price  = ngwState.price;
  const bonus  = Math.round(price * 0.20 * 100) / 100;
  ngwCart.push({
    clubId:         ngwState.clubId,
    modelName:      ngwState.modelName,
    condition:      ngwState.condition,
    conditionLabel: ngwState.conditionLabel,
    price:          price,
    bonus:          bonus,
    total:          Math.round((price + bonus) * 100) / 100,
  });
  ngwRenderCart();
  ngwResetForNextClub();
}

function ngwAcceptAndContinue() {
  // Save current club to cart then go to contact step
  const price  = ngwState.price;
  const bonus  = Math.round(price * 0.20 * 100) / 100;
  ngwCart.push({
    clubId:         ngwState.clubId,
    modelName:      ngwState.modelName,
    condition:      ngwState.condition,
    conditionLabel: ngwState.conditionLabel,
    price:          price,
    bonus:          bonus,
    total:          Math.round((price + bonus) * 100) / 100,
  });
  ngwRenderCart();
  ngwGoToContact();
}

function ngwGoToContact() {
  if (!ngwCart.length) return;
  const totalCredit = ngwCart.reduce((s, i) => s + i.total, 0);
  const step3Summary = document.getElementById('ngw-step-3-summary');
  if (step3Summary) step3Summary.textContent = `$${totalCredit.toFixed(2)} store credit`;
  ngwSetStepDone(3);
  ngwSetStepActive(4);
  document.getElementById('ngw-step-4').scrollIntoView({ behavior: 'smooth' });
}

function ngwRenderCart() {
  const container = document.getElementById('ngw-cart');
  if (!container) return;
  const totalBase  = ngwCart.reduce((s, i) => s + i.price, 0);
  const totalBonus = ngwCart.reduce((s, i) => s + i.bonus, 0);
  const totalAll   = ngwCart.reduce((s, i) => s + i.total, 0);

  container.innerHTML = `
    <div class="ngw-cart-header">
      <h3>Trade-In Cart (${ngwCart.length} club${ngwCart.length > 1 ? 's' : ''})</h3>
      <span class="ngw-cart-total">$${totalAll.toFixed(2)} CAD</span>
    </div>
    ${ngwCart.map((item, i) => `
      <div class="ngw-cart-item">
        <div class="ngw-cart-item-info">
          <div class="ngw-cart-item-name">${item.modelName}</div>
          <div class="ngw-cart-item-cond">${item.conditionLabel}</div>
        </div>
        <div class="ngw-cart-item-price">$${item.total.toFixed(2)}</div>
        <button class="ngw-cart-remove" data-index="${i}" title="Remove">&#x2715;</button>
      </div>
    `).join('')}
    <div class="ngw-cart-actions">
      <button class="btn btn-secondary">+ Add Another Club</button>
      <button class="btn btn-primary">Accept &amp; Continue &#x2192;</button>
    </div>
  `;
  container.style.display = 'block';
}

function ngwRemoveFromCart(index) {
  ngwCart.splice(index, 1);
  if (ngwCart.length === 0) {
    const c = document.getElementById('ngw-cart');
    if (c) c.style.display = 'none';
    // Reactivate step 3 so user can still proceed
    ngwSetStepActive(3);
  } else {
    ngwRenderCart();
  }
}

function ngwResetForNextClub() {
  ngwState = { clubId: null, modelName: null, clubType: null, condition: null, conditionLabel: null, price: null };

  // Reset step 1
  ngwClearSearch();
  ngwResetSelect(document.getElementById('ngw-sel-brand'), 'Select a brand', false);
  ngwResetSelect(document.getElementById('ngw-sel-type'),  'Select type', true);
  ngwResetSelect(document.getElementById('ngw-sel-model'), 'Select model', true);
  // Reload brands
  ngwLoadBrands();
  document.getElementById('ngw-btn-step1').disabled = true;

  // Reset step 2
  document.querySelectorAll('.ngw-ti .condition-card').forEach(c => c.classList.remove('selected'));
  const btn2 = document.getElementById('ngw-btn-step2');
  if (btn2) { btn2.disabled = true; btn2.classList.remove('btn-loading'); }

  // Reset step visuals back to active step 1
  ['ngw-step-1', 'ngw-step-2', 'ngw-step-3'].forEach(id => {
    const s = document.getElementById(id);
    if (s) s.classList.remove('done');
  });
  document.getElementById('ngw-step-1').classList.remove('locked');
  document.getElementById('ngw-step-2').classList.add('locked');
  document.getElementById('ngw-step-3').classList.add('locked');

  document.getElementById('ngw-step-1').scrollIntoView({ behavior: 'smooth' });
}

// ─── Step 4: Contact + Submit ─────────────────────────────────────────────────
async function ngwSubmitTradein() {
  if (!ngwValidateContact()) return;
  if (!ngwCart.length) { alert('Please add at least one club.'); return; }

  const btn = document.getElementById('ngw-btn-submit');
  btn.disabled = true;
  btn.classList.add('btn-loading');

  const firstName      = document.getElementById('ngw-inp-first').value.trim();
  const lastName       = document.getElementById('ngw-inp-last').value.trim();
  const email          = document.getElementById('ngw-inp-email').value.trim();
  const phone          = document.getElementById('ngw-inp-phone').value.trim();
  const street         = document.getElementById('ngw-inp-street').value.trim();
  const city           = document.getElementById('ngw-inp-city').value.trim();
  const province       = document.getElementById('ngw-inp-province').value.trim();
  const postal         = document.getElementById('ngw-inp-postal').value.trim();
  const mailingAddress = `${street}, ${city}, ${province} ${postal}`;
  const totalBase      = ngwCart.reduce((s, i) => s + i.price, 0);
  const totalBonus     = ngwCart.reduce((s, i) => s + i.bonus, 0);
  const totalCredit    = ngwCart.reduce((s, i) => s + i.total, 0);

  const clubDescription = ngwCart.map(i => `${i.modelName} (${i.conditionLabel})`).join('; ');
  const submissionId    = 'TI-' + Date.now();

  const payload = {
    submission_id:    submissionId,
    first_name:       firstName,
    last_name:        lastName,
    email,
    phone,
    mailing_address:  mailingAddress,
    club_description: clubDescription,
    appraised_value:  String(totalBase),
  };

  try {
    // Pass apikey as URL query param instead of a request header.
    // Sending apikey/Authorization as headers triggers a CORS preflight OPTIONS
    // request which the browser blocks because the function's CORS response
    // does not include 'apikey' in Access-Control-Allow-Headers.
    // With the key in the URL, only Content-Type remains as a custom header —
    // already listed as allowed — so no preflight problem.
    const { status, responseText } = await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${NGW_SB_URL}/functions/v1/process-tradein?apikey=${NGW_SB_KEY}`);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = () => resolve({ status: xhr.status, responseText: xhr.responseText });
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(JSON.stringify(payload));
    });

    if (status < 200 || status >= 300) {
      console.error('Submission error', status, responseText);
      alert('Submission error. Please try again or call us at 905-984-6306.');
      btn.disabled = false; btn.classList.remove('btn-loading');
      return;
    }
    const resData = JSON.parse(responseText);
    if (!resData.success) {
      console.error('Submission failed', resData);
      alert('Submission error. Please try again or call us at 905-984-6306.');
      btn.disabled = false; btn.classList.remove('btn-loading');
      return;
    }

    // Success
    const successPanel = document.getElementById('ngw-success-panel');
    const successEmail  = document.getElementById('ngw-success-email');
    const successBase   = document.getElementById('ngw-success-base');
    const successBonus  = document.getElementById('ngw-success-bonus');
    const successCredit = document.getElementById('ngw-success-credit');

    if (successEmail)  successEmail.textContent  = email;
    if (successBase)   successBase.textContent    = `$${totalBase.toFixed(2)}`;
    if (successBonus)  successBonus.textContent   = `+$${totalBonus.toFixed(2)}`;
    if (successCredit) successCredit.textContent  = `$${totalCredit.toFixed(2)} CAD`;

    // Hide steps and cart
    document.querySelectorAll('.ngw-ti .step').forEach(s => { s.style.display = 'none'; });
    const cartEl = document.getElementById('ngw-cart');
    if (cartEl) cartEl.style.display = 'none';

    if (successPanel) { successPanel.classList.add('visible'); successPanel.scrollIntoView({ behavior: 'smooth' }); }
  } catch(e) {
    console.error(e);
    alert('Submission error. Please try again or call us at 905-984-6306.');
    btn.disabled = false; btn.classList.remove('btn-loading');
  }
}

function ngwValidateContact() {
  const first    = document.getElementById('ngw-inp-first')?.value.trim();
  const last     = document.getElementById('ngw-inp-last')?.value.trim();
  const email    = document.getElementById('ngw-inp-email')?.value.trim();
  const street   = document.getElementById('ngw-inp-street')?.value.trim();
  const city     = document.getElementById('ngw-inp-city')?.value.trim();
  const province = document.getElementById('ngw-inp-province')?.value.trim();
  const postal   = document.getElementById('ngw-inp-postal')?.value.trim();

  let valid = true;
  function err(id, show) {
    const el = document.getElementById(id);
    if (el) el.classList.toggle('visible', show);
  }
  if (!first)    { err('ngw-err-first', true);    valid = false; } else err('ngw-err-first', false);
  if (!last)     { err('ngw-err-last', true);     valid = false; } else err('ngw-err-last', false);
  if (!email || !email.includes('@')) { err('ngw-err-email', true); valid = false; } else err('ngw-err-email', false);
  if (!street)   { err('ngw-err-street', true);   valid = false; } else err('ngw-err-street', false);
  if (!city)     { err('ngw-err-city', true);     valid = false; } else err('ngw-err-city', false);
  if (!province) { err('ngw-err-province', true); valid = false; } else err('ngw-err-province', false);
  if (!postal || !/^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/.test(postal)) { err('ngw-err-postal', true); valid = false; } else err('ngw-err-postal', false);
  return valid;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────
function ngwSetStepDone(n) {
  const s = document.getElementById(`ngw-step-${n}`);
  if (s) { s.classList.add('done'); s.classList.remove('locked'); }
}
function ngwSetStepActive(n) {
  const s = document.getElementById(`ngw-step-${n}`);
  if (s) { s.classList.remove('locked', 'done'); }
}
function ngwResetSelect(sel, placeholder, disabled) {
  if (!sel) return;
  sel.innerHTML = `<option value="">${placeholder}</option>`;
  sel.disabled  = disabled;
}
function ngwFriendlyType(slug) {
  const map = { driver: 'Driver', fairway: 'Fairway Wood', hybrid: 'Hybrid', iron_set: 'Iron Set', individual_iron: 'Individual Iron', wedge: 'Wedge', putter: 'Putter', unknown: 'Club' };
  return map[slug] || slug;
}

function ngwRestartWidget() {
  ngwCart  = [];
  ngwState = { clubId: null, modelName: null, clubType: null, condition: null, conditionLabel: null, price: null };
  document.querySelectorAll('.ngw-ti .step').forEach((s, i) => {
    s.style.display = '';
    s.classList.remove('done');
    if (i > 0) s.classList.add('locked'); else s.classList.remove('locked');
  });
  const cartEl = document.getElementById('ngw-cart');
  if (cartEl) cartEl.style.display = 'none';
  document.getElementById('ngw-success-panel').classList.remove('visible');
  ngwClearSearch();
  ngwResetSelect(document.getElementById('ngw-sel-brand'), 'Select a brand', false);
  ngwResetSelect(document.getElementById('ngw-sel-type'),  'Select type', true);
  ngwResetSelect(document.getElementById('ngw-sel-model'), 'Select model', true);
  document.querySelectorAll('.ngw-ti .condition-card').forEach(c => c.classList.remove('selected'));
  document.getElementById('ngw-btn-step1').disabled = true;
  const btn2 = document.getElementById('ngw-btn-step2');
  if (btn2) { btn2.disabled = true; btn2.classList.remove('btn-loading'); }
  ngwLoadBrands();
  document.getElementById('ngw-step-1').scrollIntoView({ behavior: 'smooth' });
}

// ─── Boot ─────────────────────────────────────────────────────────────────────
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ngwInit);
} else {
  ngwInit();
}